import { render } from "./EnhanceTitleButton.vue?vue&type=template&id=3d32f738"
import script from "./EnhanceTitleButton.vue?vue&type=script&lang=js"
export * from "./EnhanceTitleButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__